import { FormikErrors } from "formik";
import React, { useMemo, useState } from "react";
import {
  ICandidateDetails,
  ICandidateReviewFormInput,
} from "../../../../store/superadmin/types";
import { getFormatedDate } from "../../../../utils/dataParser";
import OnlineInterviewVideoPlay from "../../../Client/Candidates/PopupModal/OnlineInterviewVideoPlay";
import Play from "../../../UI/Icons/Play";
import CharacterLimitTextarea from "../../../UI/Inputs/CharacterLimitTextarea";
import Checkbox from "../../../UI/Inputs/Checkbox";
import ErrorMessage from "../../../UI/Tooltips/ErrorMessage";

interface OnlineInterviewProps {
  showOnlineInterview: boolean;
  currentStage: number;
  values: ICandidateReviewFormInput;
  errors: FormikErrors<ICandidateReviewFormInput>;
  skipOnlineInterview: number;
  setSkipOnlineInterview: (value: number) => void;
  setFieldValue: (field: string, value: string | number) => void;
  reviewCandidateData: ICandidateDetails | null;
}

const OnlineInterview: React.FC<OnlineInterviewProps> = ({
  showOnlineInterview,
  currentStage,
  reviewCandidateData,
  values,
  errors,
  skipOnlineInterview,
  setSkipOnlineInterview,
  setFieldValue,
}) => {
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [answer, setAnswer] = useState(null);

  const viddiResponse =
    reviewCandidateData?.profile?.viddi_candidate &&
    JSON.parse(reviewCandidateData?.profile?.viddi_candidate?.viddi_response);
  


  const handleOpenVideoPopupModal = (answer: any) => {
    setShowVideoModal(true);
    setAnswer(answer);
  };

  const onClickClose = () => {
    setShowVideoModal(false);
    setAnswer(null);
  };

  const handleChange = (data: string) => {
    setFieldValue("online_interview_bypass_reason", data);
  };

  const totalQuestions = reviewCandidateData?.viddi_status?.total_questions;
  const totalAnswered = reviewCandidateData?.viddi_status?.total_answered;
  const viddiStatus = reviewCandidateData?.viddi_status?.viddi_status;
  

  const isShowStatus = useMemo(() => {
    return (
      reviewCandidateData?.viddi_status?.viddi_candidate_interview_status ===
        1 ||
      reviewCandidateData?.viddi_status.viddi_review_status === 3 ||
      reviewCandidateData?.viddi_status.viddi_review_status === 2
    );
  }, [reviewCandidateData?.viddi_status]);

  //once stage 1 submitted and viddi_status is not 3 (completed), show the bypass option to super admin
  const isStage1Submitted = reviewCandidateData?.profile?.current_stage === 1 && reviewCandidateData?.viddi_status?.viddi_status !== 3;

  return (
    <>
      <OnlineInterviewVideoPlay
        showVideoModal={showVideoModal}
        onClickClose={onClickClose}
        answer={answer}
      />

      <div
        className={`d-flex flex-column gap-20 fw-400 text-black ${
          !showOnlineInterview ? "d-none" : ""
        }`}
      >
        <div className="fs-22">Online Interview</div>         
          {
            viddiStatus === 2 &&  (
              <div className="d-flex gap-10 fs-16">This step is in progress. {totalAnswered} out of {totalQuestions} questions are completed.</div>
            )
          }       
        {
          viddiStatus === 3 && (
              <div className="d-flex gap-10 flex-wrap">Employee has successfully completed the online interview.<br /></div>
          )
        }
        {viddiStatus === 3 && viddiResponse?.interview_instance?.answers?.length > 0 && (
        <div className="d-flex gap-10 flex-column">          
          {viddiResponse?.interview_instance?.answers?.map(
              (answer: any, index: number) => (
                <div
                  key={index}
                  className="bg-white border border-grey-light radius-8px"
                >
                  <div className="d-flex flex-column gap-3 p-15px">
                    <div className="fs-16 fw-700 text-black">
                      {answer.interview_question.question_text}
                    </div>
                    <div className="fs-13 fw-400 text-black">
                      Uploaded: {getFormatedDate(answer.created_datetime)}
                    </div>
                  </div>
                  <div className="w-210px h-160px position-relative">
                    <video
                      width="210"
                      height="160"
                      className="object-fit-cover"
                      preload="metadata"
                    >
                      <source
                        src={answer.answer_video_url}
                        type="video/mp4"
                      ></source>
                    </video>
                    <div
                      className="position-absolute top-50 start-50 translate-middle cursor-pointer"
                      onClick={() => handleOpenVideoPopupModal(answer)}
                    >
                      <Play />
                    </div>
                  </div>
                </div>
              )
          )}
        </div>
        )}

       
{/* 
        {isShowStatus && (
          <div className="d-flex gap-10 fs-16">
            {viddiStatus === 3 && <div className="fs-16 fw-700">Status: </div>}
            {viddiStatus === 3 ? (
              <>
                The candidate has successfully completed the online interview.
                Please review the interview results, or bypass this step if
                necessary.
              </>
            ) : reviewCandidateData?.viddi_status.viddi_review_status === 3 ? (
              <>
                The candidate has been successfully shortlisted to move forward
                in the process.
              </>
            ) : reviewCandidateData?.viddi_status.viddi_review_status === 2 ? (
              <>
                This candidate's application has been reviewed and marked as not
                proceeding further.
              </>
            ) : (
              ""
            )}
          </div>
        )} */}
        <div className="fs-16">
          {reviewCandidateData?.viddi_status
            ?.viddi_candidate_interview_status === 0 && (
            <>This step has not been started.</>
          )}
        </div>

        {
          isStage1Submitted && (
          <div className="d-flex">
            <div className="bg-off-white p-15px radius-8px d-flex flex-column gap-12 w-100 max-w-420px">
              <div className="fs-13 fw-700">Super Admin Control</div>
              <div className="theme-check">
                <Checkbox
                  className="theme-check-input"
                  id={"bypass_online_interview"}
                  checked={
                    values.bypass_online_interview === 1 ||
                    reviewCandidateData?.profile?.bypass_online_interview === 1
                  }
                  onChange={() => {
                    const newValue = skipOnlineInterview === 0 ? 1 : 0;
                    setSkipOnlineInterview(newValue);
                    setFieldValue("bypass_online_interview", newValue);
                  }}
                  label={"Allow employee to bypass this requirement"}
                  themeCheck={true}
                  labelFontSize="13"
                  labelBold={false}
                  disabled={
                    currentStage !== 1 ||
                    // reviewCandidateData?.profile?.interview_complete_later !== 1 &&
                    (reviewCandidateData?.profile?.review_status === null &&
                      reviewCandidateData?.profile?.current_stage === null)
                  }
                />
                {errors && (
                  <ErrorMessage
                    message={String(errors.bypass_online_interview ?? "")}
                  />
                )}
              </div>
              <CharacterLimitTextarea
                maxLength={200}
                placeholder="Enter reason..."
                value={
                  values.online_interview_bypass_reason ??
                  reviewCandidateData?.profile?.step_bypass_reason?.find(
                    (type) => type.bypass_type === "bypass_online_interview"
                  )?.reason ??
                  ""
                }
                onChange={(value) => handleChange(value)}
                disabled={
                  currentStage !== 1
                    ? true
                    : values?.bypass_online_interview === 1
                    ? false
                    : true
                }
                doneBy={
                  reviewCandidateData?.profile?.step_bypass_reason?.length
                    ? reviewCandidateData.profile.step_bypass_reason.find(
                        (type) => type.bypass_type === "bypass_online_interview"
                      )
                    : undefined
                }
                error={
                  typeof errors.online_interview_bypass_reason === "string"
                    ? errors.online_interview_bypass_reason
                    : undefined
                }
              />
            </div>
          </div>
        )
        }
      </div>
    </>
  );
};

export default OnlineInterview;
